import { render, staticRenderFns } from "./contactSupportModal.vue?vue&type=template&id=22dc9232&scoped=true"
import script from "./contactSupportModal.vue?vue&type=script&lang=js"
export * from "./contactSupportModal.vue?vue&type=script&lang=js"
import style0 from "./contactSupportModal.vue?vue&type=style&index=0&id=22dc9232&prod&lang=sass&rel=stylesheets%2Fsass&scoped=true"
import style1 from "./contactSupportModal.vue?vue&type=style&index=1&id=22dc9232&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc9232",
  null
  
)

export default component.exports